import './sass/styles.scss';
import './js/jquery-global.js';
require('jquery-validation');

$(document).ready(function() {

    $('.option-garniture').click(function(e) {
        
        if($('.option-taille:checked').length == 0) {
            e.preventDefault();
            $('#garniture-taille').show();
        } else {
            let taille = $('.option-taille:checked').val();
            let max = 0;
            if(taille == "Petit") max = 4;
            else max = 6;

            if(!$(this).prop("checked")) {
                $(this).prop("checked", false);
                $(this).removeAttr('checked');
                $('#garniture-limit').hide();
            } else {
                if($('.option-garniture:checked').length > max) {
                    $('#garniture-limit').show();
                    e.preventDefault();
                } else {
                    $('#garniture-limit').hide();

                    $(this).attr("checked", "checked");
                    $(this).prop("checked", true);
                }
            }
        }
    });


    
    $('.option-topping').click(function(e) {
        
        if($('.option-taille:checked').length == 0) {
            $('#topping-taille').show();
            e.preventDefault();
        } else {
            let taille = $('.option-taille:checked').val();
            let max = 0;
            if(taille == "Petit") max = 2;
            else max = 4;

            if(!$(this).prop("checked")) {
                $(this).prop("checked", false);
                $(this).removeAttr('checked');
                $('#topping-limit').hide();
            } else {
                if($('.option-topping:checked').length > max) {
                    $('#topping-limit').show();
                    e.preventDefault();
                } else {
                    $('#topping-limit').hide();

                    $(this).attr("checked", "checked");
                    $(this).prop("checked", true);
                }
            }
        }
    });



    $('.option-taille').click(function(e) {
        if($('.option-taille:checked').length > 0) {
            $('#garniture-taille').hide();
            $('#topping-taille').hide();
            $('#garniture-limit').hide();
            $('#topping-limit').hide();
            $('.option-topping').prop("checked", false);
            $('.option-garniture').prop("checked", false);
        }
    });


        $("#commande-form").validate({
            ignore: [],
            rules: {
                nom: { required: true },
                prenom: { required: true },
                gsm: { required: true },
                email: { required: true, email: true },
                "date-desiree": { required: true },
                "heure-desiree": { required: true },
                taille: { required: true },
                base: { required: true },
                proteine: { required: true },
                marinade: { required: true },
                "garniture[]": { required: true },
                "topping[]": { required: true },
                transport: { required: true },
            },
            messages: {
                nom: { required: "Veuillez entrer votre nom" },
                prenom: { required: "Veuillez entrer votre prénom" },
                gsm: { required: "Veuillez entrer votre numéro de GSM" },
                email: { required: "Veuillez entrer votre adresse e-mail", email: "Veuillez entrer une adresse e-mail valide" },
                "date-desiree": { required: "Veuillez entrer une date de livraison souhaitée" },
                "heure-desiree": { required: "Veuillez entrer une heure de livraison souhaitée" },
                taille: { required: "Veuillez choisir une taille" },
                base: { required: "Veuillez choisir une base" },
                proteine: { required: "Veuillez choisir une protéine" },
                marinade: { required: "Veuillez choisir une marinade" },
                "garniture[]": { required: "Veuillez choisir les garnitures" },
                "topping[]": { required: "Veuillez choisir les toppings" },
                transport: { required: "Veuillez choisir votre mode de livraison" },
            },
            errorClass: "error fadeInDown order-1 mr-4",
            errorPlacement: function(error, element) 
            {
                console.log(element)
                if ( element.is(":radio") || element.is(":checkbox") ) 
                {
                    error.appendTo( element.parents('.block_choix') );
                }
                else 
                { // This is the default behavior 
                    error.insertAfter( element );
                }
             }
        });



});